export default "__VITE_PUBLIC_ASSET__0d683883__"